import { Alert, LinearProgress } from "@mui/material";
import type { FC } from "react";
import { useParams } from "react-router";
import { HeaderBar } from "../../../modules/generic/components/header-bar";
import { HeaderBarTitle } from "../../../modules/generic/components/header-bar-title";
import { Page } from "../../../modules/layout/components/page";
import { useMomentPreviewData } from "../../../modules/moment/component/buttons/preview-button/preview-dialog/hooks/use-moment-preview-data";
import { SavedMomentSendTestButton } from "../../../modules/moment/component/buttons/send-test/saved-moment-send-test-button";
import type { UUID } from "../../../utils/uuid";
import { MomentReview } from "./moment-review";

const MomentReviewPage: FC<{ isNewsletter?: boolean }> = ({ isNewsletter }) => {
  const { id } = useParams<{ id: UUID }>();

  if (!id) return null;
  return <LoadedMomentReviewPage momentId={id} isNewsletter={isNewsletter} />;
};

const LoadedMomentReviewPage: FC<{ momentId: UUID; isNewsletter?: boolean }> = ({
  momentId,
  isNewsletter,
}) => {
  const { data, loading } = useMomentPreviewData(momentId);

  if (loading) return <LinearProgress />;
  if (!data)
    return (
      <Alert severity="info" sx={{ m: 3 }}>
        This Communication isn’t open to you for review. Ask whoever sent it to you to send it
        again.
      </Alert>
    );

  return (
    <Page title={`${data.title} | ChangeEngine`} sx={{ height: "100%" }}>
      <HeaderBar navBurger>
        <HeaderBarTitle
          title={{ type: "fixed", value: data.title }}
          subtitle={data.program?.title ?? undefined}
          channel={data.channel}
          status={data.status}
          reviewStatus={data.review_status ?? undefined}
        />
      </HeaderBar>
      <MomentReview
        momentId={momentId}
        data={data}
        isNewsletter={isNewsletter}
        buttons={{
          sendTest: <SavedMomentSendTestButton momentId={momentId} channel={data.channel} />,
        }}
      />
    </Page>
  );
};

export default MomentReviewPage;
